
define('css!application/global/login/login',[],function(){});
